import { Linkedin, ArrowUp } from "lucide-react";
import logo from "@/assets/logo-optimized.webp";

const footerLinks = [
  { label: "About", href: "/#about" },
  { label: "Case Studies", href: "/#case-studies" },
  // { label: "Tools", href: "/#tools" }, // Hidden for now
  { label: "Insights", href: "/#insights" },
  { label: "Contact", href: "/#contact" },
];

export function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-foreground text-background py-12 md:py-16" role="contentinfo">
      <div className="container-wide">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-8 mb-12">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img 
              src={logo} 
              alt="" 
              className="w-10 h-10 object-contain"
              aria-hidden="true"
            />
            <span className="font-semibold text-lg">Digital Executive</span>
          </div>

          {/* Navigation */}
          <nav className="flex flex-wrap gap-6" aria-label="Footer navigation">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-background/70 hover:text-background transition-colors focus:outline-none focus:ring-2 focus:ring-background focus:ring-offset-2 focus:ring-offset-foreground rounded-sm"
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/in/brianjkopp/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-background/10 flex items-center justify-center hover:bg-background/20 transition-colors focus:outline-none focus:ring-2 focus:ring-background focus:ring-offset-2 focus:ring-offset-foreground"
              aria-label="Connect on LinkedIn (opens in new tab)"
            >
              <Linkedin className="w-5 h-5" aria-hidden="true" />
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between pt-8 border-t border-background/10">
          <p className="text-sm text-background/60 mb-4 sm:mb-0">
            © {new Date().getFullYear()} Digital Transformation Executive. All rights reserved.
          </p>
          
          <button
            onClick={scrollToTop}
            className="inline-flex items-center gap-2 text-sm text-background/60 hover:text-background transition-colors focus:outline-none focus:ring-2 focus:ring-background focus:ring-offset-2 focus:ring-offset-foreground rounded-md px-2 py-1"
            aria-label="Scroll back to top of page"
          >
            Back to top
            <ArrowUp className="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
      </div>
    </footer>
  );
}
